export const provinceTranslations: Record<string, string> = {
    NL: 'Newfoundland and Labrador',
    NB: 'New Brunswick',
    NS: 'Nova Scotia',
    PE: 'Prince Edward Island',
    QC: 'Quebec',
    ON: 'Ontario',
    MB: 'Manitoba',
    SK: 'Saskatchewan',
    AB: 'Alberta',
    BC: 'British Columbia',
    YT: 'Yukon',
    NT: 'Northwest Territories',
    NU: 'Nunavut',
};
